module.exports = __webpack_public_path__ + "img/learner-quiz-Collaborator-Shadow.657fef1a.png";